import 'react-lazy-load-image-component/src/effects/blur.css';

import { ReactComponent as ArrowLeftIcon } from '../../../../assets/arrow-left.svg';
import { EnergyGuideResponse } from '../../../../models/EnergyGuideResponse';
import ImagePlaceholder from '../../../../assets/image-placeholder.png';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import React from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
export interface EnergyGuidesItemProps {
  item: EnergyGuideResponse;
  className?: string;
}
export default function EnergyGuidesItem({ item, className }: EnergyGuidesItemProps) {
  const { t } = useTranslation();
  return (
    <li className={classNames('energy-guides__carousel__item', className)}>
      <div className="energy-guides__carousel__item__image">
        <LazyLoadImage
          src={item.imageUri}
          alt={ImagePlaceholder}
          effect="blur"
          wrapperProps={{
            // If you need to, you can tweak the effect transition using the wrapper style.
            style: { transitionDelay: '1s' },
          }}
        />
      </div>
      <div className="energy-guides__carousel__item__body">
        <p className="energy-guides__carousel__item__body__content">{item.content}</p>
        <div className="energy-guides__carousel__item__body__link">
          <ArrowLeftIcon className="detail-header__content__icon" width={24} height={24} />
          <a href={item.link} target="_blank" rel="noreferrer">
            {t('common.read.article')}
          </a>
        </div>
      </div>
    </li>
  );
}
